import { parse, stringify, type ParsedUrlQueryInput } from 'node:querystring';

export interface RepairRequestQuery {
  sn?: string;
}

/** Legacy Breitling-compatible base64 query payload for `/service/request/watch?q=…`. */
export function encodeRepairRequestQuery(params: RepairRequestQuery): string {
  return Buffer.from(stringify(params as ParsedUrlQueryInput)).toString('base64');
}

export function decodeRepairRequestQuery(encoded: string): RepairRequestQuery | null {
  try {
    const parsed = parse(Buffer.from(encoded, 'base64').toString('utf8'));
    const sn = parsed.sn;

    return {
      sn: typeof sn === 'string' ? sn : undefined,
    };
  } catch {
    return null;
  }
}

export function buildRepairRequestWatchPath(serialNumber?: string | null): string {
  const trimmed = serialNumber?.trim();
  if (!trimmed) return '/service/request/watch';

  return `/service/request/watch?q=${encodeURIComponent(encodeRepairRequestQuery({ sn: trimmed }))}`;
}
